import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Home from "./pages/Home";
import Music from "./pages/Music";
import Fashion from "./pages/Fashion";
import Art from "./pages/Art";
import Events from "./pages/Events";
import Contact from "./pages/Contact";
import Services from "./pages/Services";
import Gaming from "./pages/Gaming";
import Culture from "./pages/Culture";
import Shop from "./pages/Shop";
import AppPage from "./pages/AppPage";
import Downloads from "./pages/Downloads";
import Slawn from "./pages/culture/Slawn";
import FashionRoundup from "./pages/culture/FashionRoundup";
import MusicRoundup from "./pages/culture/MusicRoundup";
import Invest from "./pages/culture/Invest";
import Members from "./pages/Members";
import Availability from "./pages/Availability";
import MemberProfile from "./pages/MemberProfile";
import CreatorsRoom from "./pages/CreatorsRoom";
import NewsCenter from "./pages/NewsCenter";
import Chat from "./pages/Chat";
import AuthCallback from "./pages/AuthCallback";
import AdminPanel from "./pages/AdminPanel";
import Welcome from "./pages/Welcome";
import Apply from "./pages/Apply";
import BrandsHub from "./pages/BrandsHub";
import Excourtier from "./pages/brands/Excourtier";
import KoreVelum from "./pages/brands/KoreVelum";
import Supreme from "./pages/brands/Supreme";
import MJsBodega from "./pages/brands/MJsBodega";
import Jordan from "./pages/brands/Jordan";
import Us from "./pages/brands/Us";
import SwampboySoap from "./pages/brands/SwampboySoap";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import TheShirt from "./pages/TheShirt";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { FeedProvider } from "./context/FeedContext";
import CartDrawer from "./components/CartDrawer";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <FeedProvider>
            <CartProvider>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/home" element={<Home />} />
                <Route path="/music" element={<Music />} />
                <Route path="/fashion" element={<Fashion />} />
                <Route path="/art" element={<Art />} />
                <Route path="/events" element={<Events />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/services" element={<Services />} />
                <Route path="/gaming" element={<Gaming />} />
                <Route path="/culture" element={<Culture />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/app" element={<AppPage />} />
                <Route path="/downloads" element={<Downloads />} />
                <Route path="/culture/slawn" element={<Slawn />} />
                <Route path="/culture/fashion" element={<FashionRoundup />} />
                <Route path="/culture/music" element={<MusicRoundup />} />
                <Route path="/culture/invest" element={<Invest />} />
                <Route path="/members" element={<Members />} />
                <Route path="/availability" element={<Availability />} />
                <Route path="/members/:id" element={<MemberProfile />} />
                <Route path="/creators-room" element={<CreatorsRoom />} />
                <Route path="/news" element={<NewsCenter />} />
                <Route path="/chat" element={<Chat />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/admin" element={<AdminPanel />} />
                <Route path="/welcome" element={<Welcome />} />
                <Route path="/apply/:kind" element={<Apply />} />
                <Route path="/hosted-brands" element={<BrandsHub />} />
                <Route path="/brands/excourtier" element={<Excourtier />} />
                <Route path="/brands/kore-velum" element={<KoreVelum />} />
                <Route path="/brands/supreme" element={<Supreme />} />
                <Route path="/brands/mjs-bodega" element={<MJsBodega />} />
                <Route path="/brands/jordan" element={<Jordan />} />
                <Route path="/brands/us" element={<Us />} />
                <Route path="/brands/swampboy-soap" element={<SwampboySoap />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/the-shirt" element={<TheShirt />} />
              </Routes>
              <CartDrawer />
            </CartProvider>
          </FeedProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
